import { useState } from 'react'
import clsx from 'clsx'
import styles from './Footer.module.scss'
import { showInfoMessage } from '../toastMessage'

function Footer() {
    const [valueSubmid, setValueSubmit] = useState('')

    const handleSubmit = (e) => {
        e.preventDefault()
        if (valueSubmid === '') {
            showInfoMessage('Chưa nhập lời nhắn!')
            return
        }
        const subject = encodeURIComponent('Xin chào tôi đến từ PHIMMOI!')
        const body = encodeURIComponent(valueSubmid)
        window.location.href = `mailto:nguyenducdo009@gmail.com?subject=${subject}&body=${body}`
    }

    return (
        <footer>
            <div className={styles.footer__row}>
                <div className={styles.footer__column}>
                    <h3>Về chúng tôi</h3>
                    <p> </p>
                </div>
                <div className={styles.footer__column}>
                    <h3>Liên hệ</h3>
                    <ul>
                        {/* <li>
                            <a title='Mua code liên hệ zalo' href="https://zalo.me/0879292571" target="_blank">
                                <i class="fa-solid fa-phone"></i>
                                <span>Zalo</span>
                            </a>

                        </li> */}
                        <li>
                            // <a title='PHIMMOI trên Telegram' href="https://t.me/ndd2105" target="_blank">
                            //     <i className="fa-brands fa-telegram"></i>
                            //     <span>Telegram</span>
                            // </a>
                        </li>
                    </ul>
                </div>
                <div className={styles.footer__column}>
                    <h3>Nguồn phim kkphim.com</h3>
                    <p>
                        Tất cả nội dung của trang web này đều được tìm kiếm và thu thập ở các trang web phát video trực tuyến chính thống trên Internet, cũng như không cung cấp phát trực tuyến chính hãng.
                        Nếu quyền lợi của bạn bị vi phạm, hãy liên hệ với chúng tôi. Chúng tôi sẽ xử lý và xóa các nội dung liên quan đó kịp thời. Xin cảm ơn!
                    </p>
                </div>
                <div className={styles.footer__column}>
                    <h3>Gửi phản hồi</h3>
                    <form className={styles.footer__form}>
                        <label>
                            <i className="fa-regular fa-message"></i>
                            Lời nhắn
                        </label>
                        <textarea
                            value={valueSubmid}
                            onChange={(e) => setValueSubmit(e.target.value)}
                            placeholder='Hãy phản hồi một cách văn minh và lịch sự!'>
                        </textarea>

                        <button
                            onClick={(e) => handleSubmit(e)}
                            className={clsx('btn', 'btn--primary')}
                        >
                            Gửi
                        </button>
                    </form>
                </div>
            </div>
            <div className={styles.footer__row}>
                <p className={styles.footer__copyright}>© 2024 - PHIMMOI. Web xem phim chất lượng, không quảng cáo làm phiền.</p>
            </div>
        </footer>
    )
}

export default Footer
